'use client';

import { useEffect } from 'react';

import { MiniKit } from '@worldcoin/minikit-js';

import config from 'utils/config';

declare const window: any;

const useWorldApp = () => {
    const shouldInstallMiniKit = !!window.WorldApp && config.wolrdCoinAppId && !MiniKit.isInstalled();

    useEffect(
        () => {
            // Passing appId in the install is optional
            // but allows you to access it later via `window.MiniKit.appId`
            if (shouldInstallMiniKit) {
                MiniKit.install(config.wolrdCoinAppId);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [shouldInstallMiniKit],
    );
};
export default useWorldApp;
